<div class="container">
    <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
            <div class="software-content">
                <span>Our Working Process</span>
                <h2>Value Category</h2>
                <p>When you partner with VE& More, you can expect both quality and value. Early in the design phase of a construction project, the VE& More team works collaboratively with the client and architect to apply value engineering techniques.</p>
                <ul class="features-list">
                    <li *ngFor="let category of CategoriesData"><span>{{category.name}}</span></li>
                </ul>
            </div>
        </div>
        <div class="col-lg-6 col-md-12">
            <div class="software-image">
                <img src="assets/img/software.png" alt="image">
            </div>
        </div>
    </div>
</div>
